define('viewmodels/tournaments/TournamentViewModel',[
    'knockout'
], function (ko) {

    // This model fails the `max-statements` rule.
    //
    // Not quite sure how we could improve this.
    // Since this is a just a view model that is used in many places, it is
    // kind of expected to have this many statements inside it.
    function TournamentViewModel (TournamentDetailsDialog,
                                  TournamentDetailsCardDialog,
                                  getCmsField,
                                  reelRaceCmsFetcher,
                                  campaignViewModel,
                                  tournament) {

        var self = this,
            firstPrizeName,
            playerEntry = tournament.playerLeaderboard.playerEntry;

        firstPrizeName = tournament.firstPrize.name;

        self.currentPlayerOptedIn = tournament.isParticipating;

        self.currentPlayerPosition = playerEntry.property('position');
        self.currentPlayerPoints = playerEntry.property('points');
        self.currentPlayerRemainingSpins = playerEntry.property('remainingSpins');

        self.hasFinished = tournament.isFinished;

        self.winner = tournament.winner;

        self.isSpecificGameTournament = tournament.isSpecificGameTournament;

        // @todo Integrate with the striped progress buttons
        self.joinTournament = function () {
            return tournament.enterTournamentCommand.dispatchAsPromise();
        };

        self.startsOnTheHour = tournament.startTime.minutes() === 0;
        self.startTime24h = tournament.startTime.format(self.startsOnTheHour ? 'ha' : 'h:mm');

        self.showDetailedView = ko.observable(false);

        self.startTime = tournament.startTime;
        self.endTime = tournament.endTime;

        self.formattedTime = getCmsField('formatted_time');

        self.isPromoted = tournament.isPromoted;

        self.isFromToday = tournament.isFromToday.bind(tournament);

        self.formattedTime = ko.pureComputed(function () {

            if (tournament.startTime.minutes() === 0) {
                return reelRaceCmsFetcher('tournament_time_on_the_hour')();
            }

            return reelRaceCmsFetcher('tournament_time')();

        });

        self.formattedPoints = reelRaceCmsFetcher('points_template');

        self.nextAtTime = ko.pureComputed(function () {

            if (tournament.isFromToday()) {
                return getCmsField('next_at_time')();
            }

            return getCmsField('tomorrow_at_time')();

        }).replacements({
            time: self.startTime24h
        });

        self.promotedAtTime = ko.pureComputed(function () {

            if (tournament.isFromToday()) {
                return getCmsField('promoted_at_time')();
            }

            return getCmsField('promoted_tomorrow_at_time')();

        }).replacements({
            time: self.startTime24h
        });

        self.promotedAtTimeCleanText = ko.pureComputed(function () {
            if (tournament.isFromToday()) {
                return getCmsField('today_at_time_unformatted')();
            }

            return getCmsField('tomorrow_at_time_unformatted')();
        })

        self.promotedText = ko.pureComputed(function () {

            if (tournament.isFromToday()) {
                return getCmsField('promoted_text')();
            }

            return getCmsField('promoted_tomorrow_text')();

        }).replacements({
            time: self.startTime24h,
            itemName: firstPrizeName
        });

        /* eslint-disable max-len */
        self.promotedTournamentBackgroundImageUrl = campaignViewModel.promotedTournamentBackgroundImageUrl;
        /* eslint-enable max-len */

        self.nextCountdown = ko.pureComputed(function () {

            if (tournament.isParticipating()) {
                return getCmsField('your_next_countdown')();
            }

            return getCmsField('next_countdown')();

        }).replacements({
            countdown: ko.observable(tournament.startTime).extend({ moment: true }).fromNow
        });

        self.gamePlayedText = reelRaceCmsFetcher('game_played');
        self.showLeaderboardText = reelRaceCmsFetcher('leaderboard_cta');

        self.info = getCmsField('tournament_info').replacements({
            minBet: tournament.minBet,
            duration: tournament.duration,
            spinLimit: tournament.spinLimit
        });

        self.shortInfo = getCmsField('tournament_info_short').replacements({
            minBet: tournament.minBet,
            duration: tournament.duration,
            spinLimit: tournament.spinLimit
        });

        self.firstPrize = getCmsField('tournament_first_prize').replacements({
            itemName: firstPrizeName
        });
        self.firstPrizeImageUrl = tournament.firstPrize.imageUrl;

        self.hintsIntro = getCmsField('hints_intro');
        self.specificGame = ko.pureComputed(function () {
            if (self.isSpecificGameTournament()) {
                return tournament.specificGame();
            }
        });

        self.genericHints = getCmsField('hints').replacements({
            minBet: tournament.minBet
        }).pipe(Array, function (hints) {
            return hints.split('\n');
        });

        self.specificGameHints = getCmsField('hints_single_game').replacements({
            gameName: self.specificGame.property('name'),
            minBet: tournament.minBet
        }).pipe(Array, function (hints) {
            return hints.split('\n');
        });

        self.genericTitle = getCmsField('mobile_race_title');
        self.specificGameTitle = getCmsField('mobile_race_title_single').replacements({
            name: self.specificGame.property('name')
        });
        self.promotedGenericTitle = getCmsField('mobile_promoted_race_title');

        /* eslint-disable max-len */
        self.promotedSpecificGameTitle = getCmsField('mobile_promoted_race_title_single').replacements({
            name: self.specificGame.property('name')
        });
        /* eslint-enable max-len */

        self.title = ko.pureComputed(function () {
            if (self.isSpecificGameTournament()) {

                if (self.isPromoted) {
                    return self.promotedSpecificGameTitle();
                } else {
                    return self.specificGameTitle();
                }

            } else {

                if (self.isPromoted) {
                    return self.promotedGenericTitle();
                } else {
                    return self.genericTitle();
                }

            }
        });

        self.hints = ko.pureComputed(function () {
            if (self.isSpecificGameTournament()) {
                return self.specificGameHints();
            }

            return self.genericHints();
        });

        // @todo camilleriluke While you're there, this looks totally broken
        self.inText = ko.pureComputed(function () {

            if (tournament.isFromToday()) {
                return getCmsField('next_at_time').pipe(function () {
                    return ': <b>{{time}}</b>';
                })();
            }

            return getCmsField('tomorrow_at_time').pipe(function () {
                return 'tomorrow: <b>{{time}}</b>';
            })();

        }).replacements({
            time: self.startTime24h
        });

        self.joinButtonText = getCmsField('join_button');

        self.scheduleNextText = getCmsField('schedule_next_text');

        self.scheduleLine = getCmsField('schedule_line').replacements({
            itemName: firstPrizeName,
            minBet: tournament.minBet
        });

        self.minBetText = reelRaceCmsFetcher('min_bet');
        self.minBet = tournament.minBet;

        self.prizeList = tournament.prizeList;
        self.prizeListText = getCmsField('prize_list_text');

        self.showingPrizes = ko.observable(false);

        self.togglePrizesButtonText = ko.pureComputed(function () {
            return getCmsField(self.showingPrizes() ?
                               'hide_prizes_button' :
                               'show_prizes_button')();
        });

        self.showingLeaderboard = ko.observable(false);

        self.toggleLeaderboardButtonText = ko.pureComputed(function () {
            return getCmsField(self.showingLeaderboard() ?
                               'hide_leaderboard_button' :
                               'show_leaderboard_button')();
        });

        self.detailsDialog = new TournamentDetailsDialog(campaignViewModel,
                                                         this);

        self.detailsCardDialog = new TournamentDetailsCardDialog(campaignViewModel.campaignTitle,
                                                                 this);

        self.leaderboardTitle = getCmsField('leaderboard_title').replacements({
            gameName: self.specificGame.property('name')
        });

        self.leaderboardInProgressButtonText = getCmsField('leaderboard_in_progress_button');
        self.leaderboardRank = getCmsField('leaderboard_rank');
        self.leaderboardPrize = getCmsField('leaderboard_prize');
        self.leaderboardPlayer = getCmsField('leaderboard_player');
        self.leaderboardPoints = getCmsField('leaderboard_points');

        self.leaderboard = tournament.leaderboard;
        self.playerLeaderboard = tournament.playerLeaderboard;

        self.leaderboardWinnerText = ko.pureComputed(function () {

            if (tournament.leaderboard.isPlayerWinning()) {
                return getCmsField('you_won_text')();
            }

            return getCmsField('winner_text')();

        }).replacements({
            playerName: self.leaderboard.entries.property(0).property('playerName')
        });

        self.tripleWinBoosterPoints = getCmsField('triple_win_booster_points');
        self.tripleBigWinBoosterPoints = getCmsField('triple_big_win_booster_points');
        self.megaWinBoosterPoints = getCmsField('mega_win_booster_points');

        self.tripleWinBoosterStreak = ko.pureComputed(function () {
            return playerEntry().boosters.winsInARow() % 3;
        });

        self.doubleBigWinBoosterLevel = ko.pureComputed(function () {
            return playerEntry().boosters.bigWins() % 2;
        });

        self.remainingSpinsText = getCmsField('remaining_spins').replacements({
            remainingSpins: playerEntry.property('remainingSpins')
        });

        self.pickAGameText = reelRaceCmsFetcher('opted_in_cta');
        self.pickASpecificGameText = reelRaceCmsFetcher('opted_in_cta_single_game').replacements({
            name: self.specificGame.property('name')
        });

        self.prizeImageUrlByPosition = function (position) {

            var prize = tournament.prizes[position - 1];

            return prize ? prize.imageUrl() : null;
        };

        self.finalResultText = getCmsField('final_result_heading');

        self.tournamentCardText = getCmsField('tournament_card_text');
    }

    return TournamentViewModel;

});

